import { routeArr } from '@/router'
import { getRouters } from '@/api/login'
import Layout from '@/layout/index'
import ParentView from '@/components/ParentView/index'

const route = {
    state: {
        // 所有的路由
        routes: [],
        // 动态新增的路由
        addRoutes: [],
        // 侧边导航栏需要的路由
        sidebarRouters: [],
        //当前路由
        currentRoutes: {}
    },
    mutations: {
        SET_ROUTES: (state, routes) => {
            state.addRoutes = routes
            state.routes = routeArr.concat(routes)
            state.sidebarRouters = routeArr.concat(routes)
        },
        SET_CURRENT_ROUTES: (state, routes) => {
            state.currentRoutes = routes
        }
    },
    actions: {
        // 生成路由
        GenerateRoutes({ commit }) {
            return new Promise(resolve => {
                // 向后端请求路由数据
                getRouters().then(res => {
                    const routerJson = JSON.parse(JSON.stringify(res.data))
                    const routers = filterRouter(routerJson)
                    routers.push({ path: '*', redirect: '/404', hidden: true })
                    commit('SET_ROUTES', routers)
                    resolve(routers)
                })
            })
        }
    }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterRouter(routerMap) {
    const introductions = require.context('@/views/', true, /\.vue$/);
    const introductionsLength = introductions.keys();
    let fileList=[]
    if(introductionsLength.length){ // 路径
        introductionsLength.forEach(fileName => {//获取已存在页面的路径 .vue
            fileList.push(fileName);
        });
    }
    return routerMap.filter(route => {
       if(!route.path){
        return false
       }
        if (route.component ) {
            if(!route.path || route.path==='/null' || route.path==='null'){
                route.path = "";
            }
            if (route.component === 'layout') {
                route.component = Layout
            } else if(route.component === 'parentView'){
                route.component = ParentView
            } else {
                route.component = loadView(fileList,route.component)
            }
        }
        if (route.children != null && route.children && route.children.length) {
            route.children = filterRouter(route.children)
        }
        return true
    })
}
export const loadView = (fileList,view) => { // 路由懒加载
    let ifFind=fileList.findIndex(item=>item==("./"+view+'.vue'))//判断路径是否存在
    return (resolve) => require([`@/views/${ifFind>-1?view:'error/null'}`], resolve)
}
export default route
